module.exports = __webpack_public_path__ + "static/media/ring.bfa83b99.jpg";